import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Logo from './Logo';

const Navbar = () => {
  const { isAuthenticated, user, logout } = useAuth();
  const [open, setOpen] = useState(false);
  const close = () => setOpen(false);

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <Link to="/" className="navbar-brand" onClick={close}>
          <Logo height={36} />
        </Link>

        <button
          className="navbar-toggle"
          aria-label="Toggle menu"
          aria-expanded={open}
          onClick={() => setOpen((o) => !o)}
        >
          {open ? '✕' : '☰'}
        </button>

        <ul className={`navbar-menu ${open ? 'open' : ''}`}>
          {isAuthenticated ? (
            <>
              <li><Link to="/dashboard" onClick={close}>Dashboard</Link></li>
              <li><Link to="/book-subscription" onClick={close}>Subscriptions</Link></li>
              <li><Link to="/book-alacarte" onClick={close}>Dry Cleaning</Link></li>
              <li><Link to="/my-orders" onClick={close}>My Orders</Link></li>
              {user?.isAdmin && <li><Link to="/admin" onClick={close}>Admin</Link></li>}
              <li>
                <button onClick={() => { logout(); close(); }} className="btn btn-outline">Logout</button>
              </li>
            </>
          ) : (
            <>
              <li><Link to="/pricing" onClick={close}>Pricing</Link></li>
              <li><Link to="/about" onClick={close}>About</Link></li>
              <li><Link to="/faq" onClick={close}>FAQ</Link></li>
              <li><Link to="/contact" onClick={close}>Contact</Link></li>
              <li><Link to="/login" onClick={close}>Login</Link></li>
              <li><Link to="/register" className="btn btn-primary" onClick={close}>Get Started</Link></li>
            </>
          )}
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
